import React from 'react';

import { CustomOfferFormValues } from '@/typings/formValues';
import { Control, Controller, FieldErrors, UseFormWatch } from 'react-hook-form';

import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

type Props = {
  control: Control<CustomOfferFormValues>;
  errors: FieldErrors<CustomOfferFormValues>;
  hasOrders: boolean;
  isSubmitting: boolean;
  watch: UseFormWatch<CustomOfferFormValues>;
  /** When set, show this helper text to the right of GST Amount (LEBT Hotel/Flight). */
  australiaGstHelperText?: string;
};

export default function CustomOfferGstWidget({
  control,
  errors,
  hasOrders,
  isSubmitting,
  watch,
  australiaGstHelperText,
}: Props) {
  return (
    <>
      <Box mt={2}>
        <Typography variant="h6">GST Details</Typography>
      </Box>
      <Grid mt={2} container columns={6} spacing={2} alignItems="center">
        <Grid size={{ xs: 3, md: 1 }}>
          <Controller
            name="payment_metadata.price_includes_gst"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={field.value ?? false}
                    disabled={hasOrders || isSubmitting}
                    data-testid="price-includes-gst"
                  />
                }
                label="Price includes GST"
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 3, md: 1 }}>
          <TextField
            helperText={errors?.payment_metadata?.gst_amount?.message}
            error={!!errors?.payment_metadata?.gst_amount}
            disabled
            label="GST Amount Included"
            type="number"
            fullWidth
            data-testid="gst-amount"
            slotProps={{
              inputLabel: { shrink: true },
              input: {
                value:
                  watch('payment_metadata.gst_amount') != null
                    ? Number(watch('payment_metadata.gst_amount')).toFixed(2)
                    : 0.0,
              },
            }}
          />
        </Grid>
        {australiaGstHelperText && (
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="body2" color="text.secondary">
              {australiaGstHelperText}
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
}
